/**
 * DDDのservice
 * プレイヤーの初回再生開始位置を制御するクラス
 */
class StartController {
  constructor(player, params) {
    this.player = player;
    this.params = params;
    this.init();
  }

  /**
   * 初期化。
   * 有効・無効を判断。無効なら何もしない
   * 有効の場合はプレイヤーのコールバックを設定
   *
   * @returns bool
   */
  init() {
    // startがfalseなら何もしない
    if (!this.params || !this.params.start) {
      // alert('empty or falsesy params.start');
      return false;
    }
    // プレイヤーが無効なら何もしない
    if (this.player === false) {
      // alert('falsesy player');
      return false;
    }
    // プレイヤーにコールバックを設定
    this.handleFirstFrame();
    // this.handlePlay();
    return true;
  }

  /**
   * プレイヤーに指定された開始位置に移動するコールバックを設定する
   *
   * @returns void
   */
  handleFirstFrame() {
    // alert('in handleFirstFrame()')
    // 初回かどうかを判定するフラグ
    let onceFlg = true;
    this.player.on('firstFrame', () => {
      // alert('in on("firstFrame")');
      // alert(onceFlg);
      // alert(this.params.start);
      // console.log(this.player.seek);
      // alert(JSON.stringify(typeof(this.player.seek)));

      if (onceFlg) {
        // alert('in onceFlg == true');
        // setTimeout(() => {
          // const value = this.player.seek(this.params.start);
          // const value = this.player.seek('hoge');
          // console.log(value);
          // alert(typeof(value));

          // }, 1000);
        this.player.seek(this.params.start);
        onceFlg = false;
      }
    });
  }
  /**
   * プレイヤーに指定された開始位置に移動するコールバックを設定する
   *
   * @returns void
   */
  // handlePlay() {
  //   // alert('in handleFirstFrame()')
  //   // 初回かどうかを判定するフラグ
  //   let onceFlg = true;
  //   this.player.on('play', () => {
  //     // alert('in on("firstFrame")');
  //     // alert(onceFlg);
  //     // alert(this.params.start);
  //     // console.log(this.player.seek);
  //     // alert(JSON.stringify(typeof(this.player.seek)));

  //     if (onceFlg) {
  //       // alert('in onceFlg == true');
  //       // setTimeout(() => {
  //         this.player.seek(this.params.start);
  //         // const value = this.player.seek(this.params.start);
  //         // const value = this.player.seek('hoge');
  //         // console.log(value);
  //         // alert(typeof(value));
  //         // alert(JSON.stringify(this.player));
  //         // console.log(this.player);
  //         // console.log(this.player.seek);
  //       // }, 1000);
  //       onceFlg = false;
  //     }
  //   });
  // }

  // ***************************
  // getter / setter
  // ***************************
  get player() {
    return this._player;
  }

  /**
   * playerのsetter
   * 無効な場合はfalseを設定する
   *
   * @param {mix} val
   * @returns void
   */
  set player(val) {
    if (!val) {
      val = false;
    }else if (typeof(val.on) !== "function" || typeof(val.seek) !== "function") {
      val = false;
    }
    this._player = val;
  }
}

export default StartController;
